import { isEqual } from 'lodash-es'
import { createSelectorCreator, defaultMemoize } from 'reselect'

const deepEqualSelectorFactory = () => createSelectorCreator(defaultMemoize, isEqual)

export default deepEqualSelectorFactory
